import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, toDisplayString as _toDisplayString, vShow as _vShow, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-f8f5796e")

_pushScopeId("data-v-f8f5796e")
const _hoisted_1 = { class: "performanceOverview" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("暂无下载数据")
const _hoisted_3 = {
  class: "spacName",
  style: {"height":"500px","width":"100%"}
}
const _hoisted_4 = { style: {"width":"100%","height":"35px","display":"flex","position":"relative","border-radius":"2%"} }
const _hoisted_5 = { class: "pos_box" }
const _hoisted_6 = {
  style: {"display":"flex"},
  class: "spacName"
}
const _hoisted_7 = {
  id: "rate",
  style: {"width":"40%","height":"440px"}
}
const _hoisted_8 = { style: {"width":"98%","height":"35px","display":"flex","position":"relative","border-radius":"2%"} }
const _hoisted_9 = { class: "pos_box" }
const _hoisted_10 = {
  class: "spacName",
  style: {"display":"flex","justify-content":"flex-end"}
}
const _hoisted_11 = /*#__PURE__*/_createVNode("h5", { class: "TitleStyle" }, [
  /*#__PURE__*/_createVNode("span"),
  /*#__PURE__*/_createTextVNode("包体结构")
], -1)
const _hoisted_12 = { style: {"display":"flex"} }
const _hoisted_13 = { style: {"width":"25%"} }
const _hoisted_14 = { style: {"font-size":"14px","width":"100%"} }
const _hoisted_15 = { key: 0 }
const _hoisted_16 = /*#__PURE__*/_createVNode("div", {
  id: "struct",
  style: {"height":"500px"}
}, null, -1)
const _hoisted_17 = /*#__PURE__*/_createVNode("h5", { class: "TitleStyle" }, [
  /*#__PURE__*/_createVNode("span"),
  /*#__PURE__*/_createTextVNode("地图结构")
], -1)
const _hoisted_18 = { style: {"display":"flex"} }
const _hoisted_19 = { style: {"width":"25%"} }
const _hoisted_20 = /*#__PURE__*/_createVNode("div", {
  id: "structMap",
  style: {"height":"500px"}
}, null, -1)
const _hoisted_21 = /*#__PURE__*/_createVNode("span", { class: "subTitle" }, "◆", -1)
const _hoisted_22 = /*#__PURE__*/_createTextVNode(" 地图错误引用详情 ")
const _hoisted_23 = /*#__PURE__*/_createVNode("h5", { class: "TitleStyle" }, [
  /*#__PURE__*/_createVNode("span"),
  /*#__PURE__*/_createTextVNode("资产信息")
], -1)
const _hoisted_24 = {
  class: "spacName",
  style: {"height":"500px","width":"100%"}
}
const _hoisted_25 = /*#__PURE__*/_createVNode("h5", { class: "TitleStyle" }, [
  /*#__PURE__*/_createVNode("span"),
  /*#__PURE__*/_createTextVNode("异常资源")
], -1)
const _hoisted_26 = {
  class: "spacName",
  style: {"height":"500px","width":"100%"}
}
const _hoisted_27 = /*#__PURE__*/_createVNode("h5", { class: "TitleStyle" }, [
  /*#__PURE__*/_createVNode("span"),
  /*#__PURE__*/_createTextVNode("超大资源")
], -1)
const _hoisted_28 = /*#__PURE__*/_createTextVNode("导出")
const _hoisted_29 = /*#__PURE__*/_createVNode("h5", { class: "TitleStyle" }, [
  /*#__PURE__*/_createVNode("span"),
  /*#__PURE__*/_createTextVNode("音频超大资源")
], -1)
const _hoisted_30 = /*#__PURE__*/_createTextVNode("导出")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_option = _resolveComponent("el-option")
  const _component_el_select = _resolveComponent("el-select")
  const _component_el_form_item = _resolveComponent("el-form-item")
  const _component_el_date_picker = _resolveComponent("el-date-picker")
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_tooltip = _resolveComponent("el-tooltip")
  const _component_el_form = _resolveComponent("el-form")
  const _component_el_card = _resolveComponent("el-card")
  const _component_el_table_column = _resolveComponent("el-table-column")
  const _component_el_table = _resolveComponent("el-table")
  const _component_el_input = _resolveComponent("el-input")
  const _component_el_pagination = _resolveComponent("el-pagination")
  const _component_el_tree = _resolveComponent("el-tree")
  const _component_h8 = _resolveComponent("h8")
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")
  const _component_el_checkbox = _resolveComponent("el-checkbox")
  const _component_el_tabs = _resolveComponent("el-tabs")
  const _component_el_main = _resolveComponent("el-main")
  const _component_el_container = _resolveComponent("el-container")
  const _directive_loading = _resolveDirective("loading")

  return (_openBlock(), _createBlock(_component_el_container, null, {
    default: _withId(() => [
      _createVNode(_component_el_container, null, {
        default: _withId(() => [
          _createVNode(_component_el_main, null, {
            default: _withId(() => [
              _createVNode("div", _hoisted_1, [
                _createVNode(_component_el_tabs, {
                  modelValue: _ctx.activeName,
                  "onUpdate:modelValue": _cache[52] || (_cache[52] = ($event: any) => (_ctx.activeName = $event)),
                  type: "card",
                  onTabClick: _ctx.handleClick
                }, {
                  default: _withId(() => [
                    _createVNode(_component_el_tab_pane, {
                      label: "资源概况",
                      name: "first"
                    }, {
                      default: _withId(() => [
                        _createVNode(_component_el_card, null, {
                          default: _withId(() => [
                            _createVNode(_component_el_form, {
                              inline: true,
                              model: _ctx.form,
                              size: "mini"
                            }, {
                              default: _withId(() => [
                                _createVNode(_component_el_form_item, { label: "时间" }, {
                                  default: _withId(() => [
                                    _createVNode(_component_el_select, {
                                      modelValue: _ctx.form.date,
                                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.form.date = $event)),
                                      onChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.tableChange(['device', 'scene', 'idTest']))),
                                      placeholder: "请选择"
                                    }, {
                                      default: _withId(() => [
                                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.dateOptions, (item) => {
                                          return (_openBlock(), _createBlock(_component_el_option, {
                                            key: item.date,
                                            label: item.date,
                                            value: item.date
                                          }, null, 8, ["label", "value"]))
                                        }), 128))
                                      ]),
                                      _: 1
                                    }, 8, ["modelValue"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_el_form_item, { label: "包体资源" }, {
                                  default: _withId(() => [
                                    _createVNode(_component_el_select, {
                                      modelValue: _ctx.form.idTest,
                                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.form.idTest = $event)),
                                      onChange: _cache[4] || (_cache[4] = ($event: any) => (_ctx.tableChange([]))),
                                      placeholder: "请选择"
                                    }, {
                                      default: _withId(() => [
                                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.listOptions, (item) => {
                                          return (_openBlock(), _createBlock(_component_el_option, {
                                            key: item.id_test,
                                            label: item.version,
                                            value: item.id_test
                                          }, null, 8, ["label", "value"]))
                                        }), 128))
                                      ]),
                                      _: 1
                                    }, 8, ["modelValue"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_el_form_item, { label: "时间选择" }, {
                                  default: _withId(() => [
                                    _createVNode(_component_el_date_picker, {
                                      onChange: _ctx.pickChange,
                                      modelValue: _ctx.form.pick,
                                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.form.pick = $event)),
                                      type: "daterange",
                                      "range-separator": "To",
                                      "start-placeholder": "开始日期",
                                      "end-placeholder": "结束日期"
                                    }, null, 8, ["onChange", "modelValue"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_el_form_item, null, {
                                  default: _withId(() => [
                                    _createVNode(_component_el_tooltip, {
                                      class: "item",
                                      effect: "dark",
                                      content: "下载文件：bundle_info.cs, cooked_reference.bin",
                                      placement: "top"
                                    }, {
                                      default: _withId(() => [
                                        (
                          _ctx.listOptions.filter((v) => v.id_test == _ctx.form.idTest)[0]
                            ?.url
                        )
                                          ? (_openBlock(), _createBlock(_component_el_button, {
                                              key: 0,
                                              type: "primary"
                                            }, {
                                              default: _withId(() => [
                                                _createVNode("a", {
                                                  style: {"color":"#fff","text-decoration":"none"},
                                                  download: "",
                                                  href: 
                            _ctx.listOptions.filter(
                              (v) => v.id_test == _ctx.form.idTest
                            )[0]?.url
                          
                                                }, " 下载 ", 8, ["href"])
                                              ]),
                                              _: 1
                                            }))
                                          : (_openBlock(), _createBlock(_component_el_button, {
                                              key: 1,
                                              type: "primary"
                                            }, {
                                              default: _withId(() => [
                                                _hoisted_2
                                              ]),
                                              _: 1
                                            }))
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }, 8, ["model"]),
                            _withDirectives(_createVNode("div", _hoisted_3, [
                              _createVNode(_component_el_card, {
                                id: "trend",
                                style: {"height":"500px","width":"100%"}
                              })
                            ], 512), [
                              [_directive_loading, _ctx.trendLoading]
                            ]),
                            (_ctx.testShow)
                              ? _withDirectives((_openBlock(), _createBlock(_component_el_table, {
                                  key: 0,
                                  style: {"width":"100%"},
                                  size: "small",
                                  ref: "leftTable",
                                  lazy: "",
                                  class: "customer-table1",
                                  "header-cell-style": {
                    background: '#272727',
                    color: '#B5B5B5',
                    border: '0',
                    padding: '1px,0',
                    height: '10px',
                  },
                                  load: _ctx.load,
                                  "row-style": _ctx.tableRowClassName,
                                  "row-key": "id",
                                  data: _ctx.stackTabel?.func_list?.new,
                                  "tree-props": {
                    children: 'children',
                    hasChildren: 'is_expand',
                  }
                                }, {
                                  default: _withId(() => [
                                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.details_list, (item, index) => {
                                      return (_openBlock(), _createBlock(_component_el_table_column, {
                                        width: item.prop == 'name' ? 600 : 100,
                                        key: index,
                                        index: index,
                                        label: item.label
                                      }, {
                                        default: _withId((scope) => [
                                          _withDirectives(_createVNode("span", null, _toDisplayString(scope.row[item.prop]), 513), [
                                            [_vShow, item.prop != 'size']
                                          ]),
                                          _withDirectives(_createVNode("div", _hoisted_4, [
                                            _createVNode("div", {
                                              style: 
                            'height:35px;background:#D5720D;width:' +
                            _ctx.getcolor(scope.row.size, _ctx.allTypeSize)[0]
                          
                                            }, null, 4),
                                            _createVNode("div", {
                                              style: 
                            'height:35px;background:#BEBEBE;width:' +
                            _ctx.getcolor(scope.row.size, _ctx.allTypeSize)[1]
                          
                                            }, null, 4),
                                            _createVNode("div", _hoisted_5, _toDisplayString(_ctx.sizeCompany(scope.row.size)), 1)
                                          ], 512), [
                                            [_vShow, item.prop === 'size']
                                          ])
                                        ]),
                                        _: 2
                                      }, 1032, ["width", "index", "label"]))
                                    }), 128)),
                                    _createVNode(_component_el_table_column, {
                                      width: "100",
                                      align: "center",
                                      label: "查看趋势"
                                    }, {
                                      default: _withId((scope) => [
                                        (!scope.row.check)
                                          ? (_openBlock(), _createBlock("span", {
                                              key: 0,
                                              style: {"cursor":"pointer"},
                                              onClick: ($event: any) => (
                          _ctx.look(scope.row, scope.row.check, scope.row.name)
                        )
                                            }, "显示趋势", 8, ["onClick"]))
                                          : (_openBlock(), _createBlock("span", {
                                              key: 1,
                                              style: {"cursor":"pointer"},
                                              onClick: ($event: any) => (
                          _ctx.look(scope.row, scope.row.check, scope.row.name)
                        )
                                            }, "取消趋势", 8, ["onClick"]))
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }, 8, ["load", "row-style", "data"])), [
                                  [_directive_loading, _ctx.tableLoading]
                                ])
                              : _createCommentVNode("", true),
                            _createVNode("div", _hoisted_6, [
                              _withDirectives(_createVNode("div", _hoisted_7, null, 512), [
                                [_directive_loading, _ctx.loading]
                              ]),
                              _withDirectives(_createVNode(_component_el_table, {
                                class: "customer-table1",
                                "header-cell-style": {
                      background: '#272727',
                      color: '#B5B5B5',
                      border: '0',
                      padding: '1px,0',
                      height: '10px',
                    },
                                style: {"width":"100%"},
                                "row-style": _ctx.tableRowClassName,
                                size: "small",
                                border: "",
                                data: _ctx.typeList.results
                              }, {
                                default: _withId(() => [
                                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.details_list, (item, index) => {
                                    return (_openBlock(), _createBlock(_component_el_table_column, {
                                      key: index,
                                      index: index,
                                      label: item.label
                                    }, {
                                      default: _withId((scope) => [
                                        _withDirectives(_createVNode("span", null, _toDisplayString(scope.row[item.prop]), 513), [
                                          [_vShow, item.prop != 'size']
                                        ]),
                                        _withDirectives(_createVNode("div", _hoisted_8, [
                                          _createVNode("div", {
                                            style: 
                              'height:35px;background:#D5720D;width:' +
                              _ctx.getcolor(scope.row.size, _ctx.allsize)[0]
                            
                                          }, null, 4),
                                          _createVNode("div", {
                                            style: 
                              'height:35px;background:#BEBEBE;width:' +
                              _ctx.getcolor(scope.row.size, _ctx.allsize)[1]
                            
                                          }, null, 4),
                                          _createVNode("div", _hoisted_9, _toDisplayString(_ctx.sizeCompany(scope.row.size)), 1)
                                        ], 512), [
                                          [_vShow, item.prop === 'size']
                                        ])
                                      ]),
                                      _: 2
                                    }, 1032, ["index", "label"]))
                                  }), 128))
                                ]),
                                _: 1
                              }, 8, ["row-style", "data"]), [
                                [_directive_loading, _ctx.loading1]
                              ])
                            ]),
                            _createVNode("div", _hoisted_10, [
                              _createVNode(_component_el_form, {
                                style: {"display":"flex","align-items":"center"},
                                inline: true,
                                size: "mini"
                              }, {
                                default: _withId(() => [
                                  _createVNode(_component_el_form_item, {
                                    style: {"margin-bottom":"0"},
                                    label: "每页"
                                  }, {
                                    default: _withId(() => [
                                      _createVNode(_component_el_input, {
                                        modelValue: _ctx.size,
                                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.size = $event)),
                                        style: {"width":"55px","height":"28px"},
                                        onChange: _cache[7] || (_cache[7] = ($event: any) => (_ctx.onSearch()))
                                      }, null, 8, ["modelValue"])
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_el_form_item, {
                                    style: {"margin-bottom":"0"},
                                    label: "条记录"
                                  }),
                                  _createVNode(_component_el_form_item, { style: {"margin-bottom":"0"} }, {
                                    default: _withId(() => [
                                      _createVNode(_component_el_pagination, {
                                        style: {"text-align":"right"},
                                        currentPage: _ctx.currentPage,
                                        "onUpdate:currentPage": _cache[8] || (_cache[8] = ($event: any) => (_ctx.currentPage = $event)),
                                        "page-size": _ctx.size,
                                        total: _ctx.typeList.count,
                                        layout: "total, prev, pager, next,jumper",
                                        onCurrentChange: _cache[9] || (_cache[9] = ($event: any) => (_ctx.handleCurrentChange()))
                                      }, null, 8, ["currentPage", "page-size", "total"])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _hoisted_11,
                            _createVNode("div", _hoisted_12, [
                              _createVNode("div", _hoisted_13, [
                                _createVNode(_component_el_tree, {
                                  data: _ctx.treeData,
                                  "node-key": "id",
                                  ref: "tree",
                                  props: _ctx.defaultProps,
                                  "default-expanded-keys": _ctx.expandedKeys
                                }, {
                                  default: _withId(({ data }) => [
                                    _createVNode("span", _hoisted_14, [
                                      _createTextVNode(_toDisplayString(data.name), 1),
                                      (data.size != '')
                                        ? (_openBlock(), _createBlock("span", _hoisted_15, "：" + _toDisplayString(data.size), 1))
                                        : _createCommentVNode("", true)
                                    ])
                                  ]),
                                  _: 1
                                }, 8, ["data", "props", "default-expanded-keys"])
                              ]),
                              _createVNode(_component_el_card, { style: {"width":"70%","margin-left":"4%"} }, {
                                default: _withId(() => [
                                  _hoisted_16
                                ]),
                                _: 1
                              })
                            ]),
                            _hoisted_17,
                            _createVNode(_component_el_form, {
                              inline: true,
                              size: "mini"
                            }, {
                              default: _withId(() => [
                                _createVNode(_component_el_form_item, { label: "地图文件" }, {
                                  default: _withId(() => [
                                    _createVNode(_component_el_select, {
                                      onChange: _ctx.mapChange,
                                      modelValue: _ctx.mapFile,
                                      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_ctx.mapFile = $event)),
                                      placeholder: "请选择"
                                    }, {
                                      default: _withId(() => [
                                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.map_options, (item) => {
                                          return (_openBlock(), _createBlock(_component_el_option, {
                                            key: item.filename,
                                            label: item.filename,
                                            value: item.filename
                                          }, null, 8, ["label", "value"]))
                                        }), 128))
                                      ]),
                                      _: 1
                                    }, 8, ["onChange", "modelValue"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_el_form_item, null, {
                                  default: _withId(() => [
                                    _createVNode(_component_el_tooltip, {
                                      content: "地图错误引用下载",
                                      placement: "top"
                                    }, {
                                      default: _withId(() => [
                                        _createVNode(_component_el_button, {
                                          type: "primary",
                                          size: "mini",
                                          style: {"height":"28px"}
                                        }, {
                                          default: _withId(() => [
                                            _createVNode("a", {
                                              style: {"color":"#fff","text-decoration":"none"},
                                              download: "",
                                              href: 
                            _ctx.map_options.filter((v) => v.filename == _ctx.mapFile)[0]
                              ?.url
                          
                                            }, " 下载 ", 8, ["href"])
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode("div", _hoisted_18, [
                              _createVNode("div", _hoisted_19, [
                                _createVNode(_component_el_table, {
                                  size: "mini",
                                  data: _ctx.mapStructStack
                                }, {
                                  default: _withId(() => [
                                    _createVNode(_component_el_table_column, {
                                      label: "name",
                                      prop: "name"
                                    }),
                                    _createVNode(_component_el_table_column, {
                                      label: "size",
                                      prop: "size"
                                    }),
                                    _createVNode(_component_el_table_column, {
                                      label: "counts",
                                      prop: "count"
                                    })
                                  ]),
                                  _: 1
                                }, 8, ["data"])
                              ]),
                              _createVNode(_component_el_card, { style: {"width":"70%","margin-left":"4%"} }, {
                                default: _withId(() => [
                                  _hoisted_20
                                ]),
                                _: 1
                              })
                            ]),
                            _createVNode(_component_h8, { style: {"display":"flex","align-items":"center","margin":"8px 0 8px 0"} }, {
                              default: _withId(() => [
                                _hoisted_21,
                                _hoisted_22
                              ]),
                              _: 1
                            }),
                            _withDirectives(_createVNode(_component_el_table, {
                              size: "mini",
                              data: 
                    _ctx.mapList.slice(
                      (_ctx.map_page - 1) * _ctx.map_size,
                      _ctx.map_page * _ctx.map_size
                    )
                  ,
                              border: "",
                              "show-header": false
                            }, {
                              default: _withId(() => [
                                _createVNode(_component_el_table_column, { prop: "name" })
                              ]),
                              _: 1
                            }, 8, ["data"]), [
                              [_directive_loading, _ctx.mapLoding]
                            ]),
                            _createVNode(_component_el_form, {
                              style: {"display":"flex","align-items":"center","margin":"20px 0"},
                              inline: true,
                              size: "mini"
                            }, {
                              default: _withId(() => [
                                _createVNode(_component_el_form_item, {
                                  style: {"margin-bottom":"0"},
                                  label: "每页"
                                }, {
                                  default: _withId(() => [
                                    _createVNode(_component_el_input, {
                                      modelValue: _ctx.size,
                                      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (_ctx.size = $event)),
                                      style: {"width":"55px","height":"28px"},
                                      onChange: _cache[12] || (_cache[12] = ($event: any) => (_ctx.onSearch()))
                                    }, null, 8, ["modelValue"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_el_form_item, {
                                  style: {"margin-bottom":"0"},
                                  label: "条记录"
                                }),
                                _createVNode(_component_el_form_item, { style: {"margin-bottom":"0"} }, {
                                  default: _withId(() => [
                                    _createVNode(_component_el_pagination, {
                                      style: {"text-align":"right"},
                                      currentPage: _ctx.map_page,
                                      "onUpdate:currentPage": _cache[13] || (_cache[13] = ($event: any) => (_ctx.map_page = $event)),
                                      "page-size": _ctx.map_size,
                                      total: _ctx.mapList?.length,
                                      layout: "total, prev, pager, next,jumper"
                                    }, null, 8, ["currentPage", "page-size", "total"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_tab_pane, {
                      label: "资产信息",
                      name: "second"
                    }, {
                      default: _withId(() => [
                        _createVNode(_component_el_card, null, {
                          default: _withId(() => [
                            _hoisted_23,
                            _createVNode(_component_el_form, {
                              inline: true,
                              model: _ctx.form,
                              size: "mini"
                            }, {
                              default: _withId(() => [
                                _createVNode(_component_el_form_item, { label: "时间" }, {
                                  default: _withId(() => [
                                    _createVNode(_component_el_select, {
                                      modelValue: _ctx.form.dateOld,
                                      "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => (_ctx.form.dateOld = $event)),
                                      onChange: _cache[15] || (_cache[15] = ($event: any) => (_ctx.tableChange(['device', 'scene', 'idTest']))),
                                      placeholder: "请选择"
                                    }, {
                                      default: _withId(() => [
                                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.dateOptions, (item) => {
                                          return (_openBlock(), _createBlock(_component_el_option, {
                                            key: item.date,
                                            label: item.date,
                                            value: item.date
                                          }, null, 8, ["label", "value"]))
                                        }), 128))
                                      ]),
                                      _: 1
                                    }, 8, ["modelValue"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_el_form_item, { label: "包体资源" }, {
                                  default: _withId(() => [
                                    _createVNode(_component_el_select, {
                                      modelValue: _ctx.form.idTest_old,
                                      "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => (_ctx.form.idTest_old = $event)),
                                      onChange: _cache[17] || (_cache[17] = ($event: any) => (_ctx.tableChange([]))),
                                      placeholder: "请选择"
                                    }, {
                                      default: _withId(() => [
                                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.listOptions_old, (item) => {
                                          return (_openBlock(), _createBlock(_component_el_option, {
                                            key: item.id_test,
                                            label: item.version,
                                            value: item.id_test
                                          }, null, 8, ["label", "value"]))
                                        }), 128))
                                      ]),
                                      _: 1
                                    }, 8, ["modelValue"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_el_form_item, { label: "时间选择" }, {
                                  default: _withId(() => [
                                    _createVNode(_component_el_date_picker, {
                                      onChange: _ctx.pickChange1,
                                      modelValue: _ctx.form.secondPick,
                                      "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => (_ctx.form.secondPick = $event)),
                                      type: "daterange",
                                      "range-separator": "To",
                                      "start-placeholder": "开始日期",
                                      "end-placeholder": "结束日期"
                                    }, null, 8, ["onChange", "modelValue"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }, 8, ["model"]),
                            _withDirectives(_createVNode("div", _hoisted_24, [
                              _createVNode(_component_el_card, {
                                id: "secondtrend",
                                style: {"height":"500px","width":"100%"}
                              })
                            ], 512), [
                              [_directive_loading, _ctx.second_chart]
                            ]),
                            _createVNode(_component_el_form, {
                              inline: true,
                              model: _ctx.form,
                              size: "mini"
                            }, {
                              default: _withId(() => [
                                _createVNode(_component_el_form_item, { label: "文件名称" }, {
                                  default: _withId(() => [
                                    _createVNode(_component_el_select, {
                                      modelValue: _ctx.type,
                                      "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => (_ctx.type = $event)),
                                      onChange: _cache[20] || (_cache[20] = ($event: any) => (_ctx.pkgChange(true))),
                                      placeholder: "请选择"
                                    }, {
                                      default: _withId(() => [
                                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.pkg_type, (item) => {
                                          return (_openBlock(), _createBlock(_component_el_option, {
                                            key: item.type,
                                            label: item.type,
                                            value: item.type
                                          }, null, 8, ["label", "value"]))
                                        }), 128))
                                      ]),
                                      _: 1
                                    }, 8, ["modelValue"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_el_form_item, { label: "" }, {
                                  default: _withId(() => [
                                    _createVNode(_component_el_select, {
                                      onChange: _cache[21] || (_cache[21] = ($event: any) => (_ctx.pkgChange(true))),
                                      modelValue: _ctx.pkg_is_ignore,
                                      "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => (_ctx.pkg_is_ignore = $event)),
                                      placeholder: "请选择"
                                    }, {
                                      default: _withId(() => [
                                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.resources_list, (item) => {
                                          return (_openBlock(), _createBlock(_component_el_option, {
                                            key: item.name,
                                            label: item.name,
                                            value: item.value
                                          }, null, 8, ["label", "value"]))
                                        }), 128))
                                      ]),
                                      _: 1
                                    }, 8, ["modelValue"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_el_form_item, { label: "搜索" }, {
                                  default: _withId(() => [
                                    _createVNode(_component_el_input, {
                                      size: "mini",
                                      modelValue: _ctx.inputValue1,
                                      "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => (_ctx.inputValue1 = $event)),
                                      onChange: _cache[24] || (_cache[24] = ($event: any) => (_ctx.submit())),
                                      placeholder: "请输入文本过滤"
                                    }, null, 8, ["modelValue"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_el_form_item, null, {
                                  default: _withId(() => [
                                    _createVNode(_component_el_button, {
                                      type: "primary",
                                      size: "mini",
                                      style: {"height":"28px"}
                                    }, {
                                      default: _withId(() => [
                                        _createVNode("a", {
                                          style: {"color":"#fff","text-decoration":"none"},
                                          download: "",
                                          href: _ctx.pkg_type.filter((v) => v.type == _ctx.type)[0]?.url
                                        }, "下载", 8, ["href"])
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }, 8, ["model"]),
                            _withDirectives(_createVNode(_component_el_table, {
                              size: "mini",
                              data: _ctx.pkgAsset?.results,
                              border: ""
                            }, {
                              default: _withId(() => [
                                _createVNode(_component_el_table_column, { label: "名称" }, {
                                  default: _withId((scope) => [
                                    _createVNode("span", {
                                      style: {"white-space":"pre-wrap"},
                                      id: scope.row.name
                                    }, _toDisplayString(scope.row.name), 9, ["id"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_el_table_column, {
                                  width: "100",
                                  label: "Size(MB)"
                                }, {
                                  default: _withId((scope) => [
                                    _createTextVNode(_toDisplayString(scope.row.size), 1)
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_el_table_column, {
                                  width: "50",
                                  label: "忽略"
                                }, {
                                  default: _withId((scope) => [
                                    _createVNode(_component_el_checkbox, {
                                      modelValue: scope.row.is_ignore,
                                      "onUpdate:modelValue": ($event: any) => (scope.row.is_ignore = $event),
                                      onChange: ($event: any) => (_ctx.putPkg(scope.row))
                                    }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }, 8, ["data"]), [
                              [_directive_loading, _ctx.second_table]
                            ]),
                            _createVNode(_component_el_form, {
                              style: {"display":"flex","align-items":"center","margin":"20px 0"},
                              inline: true,
                              size: "mini"
                            }, {
                              default: _withId(() => [
                                _createVNode(_component_el_form_item, {
                                  style: {"margin-bottom":"0"},
                                  label: "每页"
                                }, {
                                  default: _withId(() => [
                                    _createVNode(_component_el_input, {
                                      modelValue: _ctx.pkg_size,
                                      "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => (_ctx.pkg_size = $event)),
                                      style: {"width":"55px","height":"28px"},
                                      onChange: _cache[26] || (_cache[26] = ($event: any) => (_ctx.pkgChange(true)))
                                    }, null, 8, ["modelValue"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_el_form_item, {
                                  style: {"margin-bottom":"0"},
                                  label: "条记录"
                                }),
                                _createVNode(_component_el_form_item, { style: {"margin-bottom":"0"} }, {
                                  default: _withId(() => [
                                    _createVNode(_component_el_pagination, {
                                      style: {"text-align":"right"},
                                      currentPage: _ctx.pkg_page,
                                      "onUpdate:currentPage": _cache[27] || (_cache[27] = ($event: any) => (_ctx.pkg_page = $event)),
                                      "page-size": _ctx.pkg_size,
                                      total: _ctx.pkgAsset?.count,
                                      layout: "total, prev, pager, next,jumper",
                                      onCurrentChange: _cache[28] || (_cache[28] = ($event: any) => (_ctx.pkgChange()))
                                    }, null, 8, ["currentPage", "page-size", "total"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_tab_pane, {
                      label: "异常资源",
                      name: "thired"
                    }, {
                      default: _withId(() => [
                        _createVNode(_component_el_card, null, {
                          default: _withId(() => [
                            _hoisted_25,
                            _createVNode(_component_el_form, {
                              inline: true,
                              model: _ctx.form,
                              size: "mini"
                            }, {
                              default: _withId(() => [
                                _createVNode(_component_el_form_item, { label: "时间" }, {
                                  default: _withId(() => [
                                    _createVNode(_component_el_select, {
                                      modelValue: _ctx.form.date_thired_old,
                                      "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => (_ctx.form.date_thired_old = $event)),
                                      onChange: _cache[30] || (_cache[30] = ($event: any) => (_ctx.tableChange_thread(['device']))),
                                      placeholder: "请选择"
                                    }, {
                                      default: _withId(() => [
                                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.dateOptions, (item) => {
                                          return (_openBlock(), _createBlock(_component_el_option, {
                                            key: item.date,
                                            label: item.date,
                                            value: item.date
                                          }, null, 8, ["label", "value"]))
                                        }), 128))
                                      ]),
                                      _: 1
                                    }, 8, ["modelValue"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_el_form_item, { label: "包体资源" }, {
                                  default: _withId(() => [
                                    _createVNode(_component_el_select, {
                                      modelValue: _ctx.form.idTest_thread_old,
                                      "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => (_ctx.form.idTest_thread_old = $event)),
                                      onChange: _cache[32] || (_cache[32] = ($event: any) => (_ctx.tableChange_thread([]))),
                                      placeholder: "请选择"
                                    }, {
                                      default: _withId(() => [
                                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.listOptions_thread_old, (item) => {
                                          return (_openBlock(), _createBlock(_component_el_option, {
                                            key: item.id_test,
                                            label: item.version,
                                            value: item.id_test
                                          }, null, 8, ["label", "value"]))
                                        }), 128))
                                      ]),
                                      _: 1
                                    }, 8, ["modelValue"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_el_form_item, { label: "时间选择" }, {
                                  default: _withId(() => [
                                    _createVNode(_component_el_date_picker, {
                                      onChange: _ctx.pickChange2,
                                      modelValue: _ctx.form.thireadPick,
                                      "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => (_ctx.form.thireadPick = $event)),
                                      type: "daterange",
                                      "range-separator": "To",
                                      "start-placeholder": "开始日期",
                                      "end-placeholder": "结束日期"
                                    }, null, 8, ["onChange", "modelValue"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }, 8, ["model"]),
                            _withDirectives(_createVNode("div", _hoisted_26, [
                              _createVNode(_component_el_card, {
                                id: "threadTrend",
                                style: {"height":"500px","width":"100%"}
                              })
                            ], 512), [
                              [_directive_loading, _ctx.thread_trend_loading]
                            ]),
                            _hoisted_27,
                            _createVNode(_component_el_form, {
                              inline: true,
                              size: "mini"
                            }, {
                              default: _withId(() => [
                                _createVNode(_component_el_form_item, null, {
                                  default: _withId(() => [
                                    _createVNode(_component_el_select, {
                                      onChange: _cache[34] || (_cache[34] = ($event: any) => (_ctx.maxChange(true))),
                                      modelValue: _ctx.big_is_ignore,
                                      "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event: any) => (_ctx.big_is_ignore = $event))
                                    }, {
                                      default: _withId(() => [
                                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.resources_list, (item) => {
                                          return (_openBlock(), _createBlock(_component_el_option, {
                                            key: item,
                                            label: item.name,
                                            value: item.value
                                          }, null, 8, ["label", "value"]))
                                        }), 128))
                                      ]),
                                      _: 1
                                    }, 8, ["modelValue"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_el_form_item, { label: "搜索" }, {
                                  default: _withId(() => [
                                    _createVNode(_component_el_input, {
                                      size: "mini",
                                      modelValue: _ctx.inputValue2,
                                      "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event: any) => (_ctx.inputValue2 = $event)),
                                      onChange: _cache[37] || (_cache[37] = ($event: any) => (_ctx.maxChange(true))),
                                      placeholder: "请输入文本过滤"
                                    }, null, 8, ["modelValue"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_el_form_item, null, {
                                  default: _withId(() => [
                                    _createVNode(_component_el_button, {
                                      type: "primary",
                                      onClick: _cache[38] || (_cache[38] = ($event: any) => (_ctx.exportMax()))
                                    }, {
                                      default: _withId(() => [
                                        _hoisted_28
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _withDirectives(_createVNode(_component_el_table, {
                              size: "mini",
                              data: _ctx.max_table,
                              border: ""
                            }, {
                              default: _withId(() => [
                                _createVNode(_component_el_table_column, { label: "资源名称" }, {
                                  default: _withId((scope) => [
                                    _createTextVNode(_toDisplayString(scope.row.name), 1)
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_el_table_column, {
                                  width: "120",
                                  label: "文件原始大小"
                                }, {
                                  default: _withId((scope) => [
                                    _createTextVNode(_toDisplayString(scope.row.size), 1)
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_el_table_column, {
                                  width: "120",
                                  label: "文件格式化大小"
                                }, {
                                  default: _withId((scope) => [
                                    _createTextVNode(_toDisplayString(scope.row.format_size), 1)
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_el_table_column, {
                                  width: "120",
                                  label: "忽略"
                                }, {
                                  default: _withId((scope) => [
                                    _createVNode(_component_el_checkbox, {
                                      onChange: ($event: any) => (_ctx.putCheck(scope.row, 'max')),
                                      modelValue: scope.row.check,
                                      "onUpdate:modelValue": ($event: any) => (scope.row.check = $event)
                                    }, null, 8, ["onChange", "modelValue", "onUpdate:modelValue"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }, 8, ["data"]), [
                              [_directive_loading, _ctx.thread_max_loading]
                            ]),
                            _createVNode(_component_el_form, {
                              style: {"display":"flex","align-items":"center","margin":"20px 0"},
                              inline: true,
                              size: "mini"
                            }, {
                              default: _withId(() => [
                                _createVNode(_component_el_form_item, {
                                  style: {"margin-bottom":"0"},
                                  label: "每页"
                                }, {
                                  default: _withId(() => [
                                    _createVNode(_component_el_input, {
                                      modelValue: _ctx.big_size,
                                      "onUpdate:modelValue": _cache[39] || (_cache[39] = ($event: any) => (_ctx.big_size = $event)),
                                      style: {"width":"55px","height":"28px"},
                                      onChange: _cache[40] || (_cache[40] = ($event: any) => (_ctx.maxChange(true)))
                                    }, null, 8, ["modelValue"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_el_form_item, {
                                  style: {"margin-bottom":"0"},
                                  label: "条记录"
                                }),
                                _createVNode(_component_el_form_item, { style: {"margin-bottom":"0"} }, {
                                  default: _withId(() => [
                                    _createVNode(_component_el_pagination, {
                                      style: {"text-align":"right"},
                                      currentPage: _ctx.big_page,
                                      "onUpdate:currentPage": _cache[41] || (_cache[41] = ($event: any) => (_ctx.big_page = $event)),
                                      "page-size": _ctx.big_size,
                                      total: _ctx.max_total,
                                      layout: "total, prev, pager, next,jumper",
                                      onCurrentChange: _cache[42] || (_cache[42] = ($event: any) => (_ctx.maxChange()))
                                    }, null, 8, ["currentPage", "page-size", "total"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _hoisted_29,
                            _createVNode(_component_el_form, {
                              inline: true,
                              size: "mini"
                            }, {
                              default: _withId(() => [
                                _createVNode(_component_el_form_item, null, {
                                  default: _withId(() => [
                                    _createVNode(_component_el_select, {
                                      onChange: _cache[43] || (_cache[43] = ($event: any) => (_ctx.videoChange(true))),
                                      modelValue: _ctx.vedio_is_ignore,
                                      "onUpdate:modelValue": _cache[44] || (_cache[44] = ($event: any) => (_ctx.vedio_is_ignore = $event))
                                    }, {
                                      default: _withId(() => [
                                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.resources_list, (item) => {
                                          return (_openBlock(), _createBlock(_component_el_option, {
                                            key: item,
                                            label: item.name,
                                            value: item.value
                                          }, null, 8, ["label", "value"]))
                                        }), 128))
                                      ]),
                                      _: 1
                                    }, 8, ["modelValue"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_el_form_item, { label: "搜索" }, {
                                  default: _withId(() => [
                                    _createVNode(_component_el_input, {
                                      size: "mini",
                                      modelValue: _ctx.inputValue3,
                                      "onUpdate:modelValue": _cache[45] || (_cache[45] = ($event: any) => (_ctx.inputValue3 = $event)),
                                      onChange: _cache[46] || (_cache[46] = ($event: any) => (_ctx.videoChange(true))),
                                      placeholder: "请输入文本过滤"
                                    }, null, 8, ["modelValue"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_el_form_item, null, {
                                  default: _withId(() => [
                                    _createVNode(_component_el_button, {
                                      type: "primary",
                                      onClick: _cache[47] || (_cache[47] = ($event: any) => (_ctx.exportVedio()))
                                    }, {
                                      default: _withId(() => [
                                        _hoisted_30
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _withDirectives(_createVNode(_component_el_table, {
                              size: "mini",
                              data: _ctx.vedio_table,
                              border: ""
                            }, {
                              default: _withId(() => [
                                _createVNode(_component_el_table_column, { label: "资源名称" }, {
                                  default: _withId((scope) => [
                                    _createTextVNode(_toDisplayString(scope.row.name), 1)
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_el_table_column, {
                                  width: "120",
                                  label: "文件原始大小"
                                }, {
                                  default: _withId((scope) => [
                                    _createTextVNode(_toDisplayString(scope.row.size), 1)
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_el_table_column, {
                                  width: "120",
                                  label: "文件格式化大小"
                                }, {
                                  default: _withId((scope) => [
                                    _createTextVNode(_toDisplayString(scope.row.format_size), 1)
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_el_table_column, {
                                  width: "120",
                                  label: "忽略"
                                }, {
                                  default: _withId((scope) => [
                                    _createVNode(_component_el_checkbox, {
                                      onChange: ($event: any) => (_ctx.putCheck(scope.row, 'vedio')),
                                      modelValue: scope.row.check,
                                      "onUpdate:modelValue": ($event: any) => (scope.row.check = $event)
                                    }, null, 8, ["onChange", "modelValue", "onUpdate:modelValue"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }, 8, ["data"]), [
                              [_directive_loading, _ctx.thread_vedio_loading]
                            ]),
                            _createVNode(_component_el_form, {
                              style: {"display":"flex","align-items":"center","margin":"20px 0"},
                              inline: true,
                              size: "mini"
                            }, {
                              default: _withId(() => [
                                _createVNode(_component_el_form_item, {
                                  style: {"margin-bottom":"0"},
                                  label: "每页"
                                }, {
                                  default: _withId(() => [
                                    _createVNode(_component_el_input, {
                                      modelValue: _ctx.video_size,
                                      "onUpdate:modelValue": _cache[48] || (_cache[48] = ($event: any) => (_ctx.video_size = $event)),
                                      style: {"width":"55px","height":"28px"},
                                      onChange: _cache[49] || (_cache[49] = ($event: any) => (_ctx.videoChange(true)))
                                    }, null, 8, ["modelValue"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_el_form_item, {
                                  style: {"margin-bottom":"0"},
                                  label: "条记录"
                                }),
                                _createVNode(_component_el_form_item, { style: {"margin-bottom":"0"} }, {
                                  default: _withId(() => [
                                    _createVNode(_component_el_pagination, {
                                      style: {"text-align":"right"},
                                      currentPage: _ctx.video_page,
                                      "onUpdate:currentPage": _cache[50] || (_cache[50] = ($event: any) => (_ctx.video_page = $event)),
                                      "page-size": _ctx.video_size,
                                      total: _ctx.vedio_total,
                                      layout: "total, prev, pager, next,jumper",
                                      onCurrentChange: _cache[51] || (_cache[51] = ($event: any) => (_ctx.videoChange()))
                                    }, null, 8, ["currentPage", "page-size", "total"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue", "onTabClick"])
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
})